import React, {Component, Fragment} from 'react';
import {toCurrency} from "../shared/functions";

class DialogSaleReceipt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            additionalTaxTypes: this.assembleTaxTypes(props.payments)
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (JSON.stringify(nextProps.payments) !== JSON.stringify(this.props.payments)) {
            this.setState({
                additionalTaxTypes: this.assembleTaxTypes(nextProps.payments)
            })
        }
    }

    assembleTaxTypes = (payments) => {
        let taxTypes = [];
        if (!payments || payments.length === 0) {
            return [];
        }
        const taxes = payments[0].additional_taxes;
        if (taxes && taxes.length > 0) {
            for (let i = 0; i < taxes.length; i++) {
                taxTypes.push({
                    machine_name: taxes[i].machine_name,
                    name: taxes[i].name,
                    amount: 0,
                    currency: '0'
                });
            }
        }
        payments.forEach((item, index) => {
            const at = item.additional_taxes;
            if (at && at.length > 0) {
                at.forEach((taxItem, index) => {
                    const idx = taxTypes.findIndex(r => r.machine_name === taxItem.machine_name);
                    if (idx !== -1) {
                        taxTypes[idx].amount += parseInt(taxItem.amount, 10);
                        taxTypes[idx].currency = toCurrency(taxTypes[idx].amount, true);
                    }
                })
            }

        })
        return taxTypes;
    }

    makeProductRows = (list) => {
        if (!list || !list.length) {
            return (
                <tr key={`receipt-products-empty`}>
                    <td colSpan={4}>
                    </td>
                </tr>
            )
        }
        return (
            list.map((item, index) => (
                <tr key={`receipt-product-${index}`}>
                    <td className="product truncate">{item.product_name}</td>
                    <td className="qty align-right">{item.qty}</td>
                    <td className="currency align-right">${item.price_each_display}</td>
                    <td className="currency align-right">${item.price_subtotal_display}</td>
                </tr>
            ))
        )
    };

    makeDiscountRows = (list) => {
        if (!list || !list.length) {
            return (
                <tr key={`receipt-discounts-empty`}>
                    <td colSpan={2}>
                    </td>
                </tr>
            )
        }
        return (
            list.map((item, index) => (
                <tr key={`receipt-discount-${index}`}>
                    <td>{item.name}</td>
                    <td className="currency align-right">${item.discount_each}</td>
                </tr>
            ))
        )
    };

    makePaymentRows = (list) => {
        if (!list || !list.length) {
            return (
                <tr key={`receipt-payments-empty`}>
                    <td colSpan={2}>
                    </td>
                </tr>
            )
        }
        return (
            list.map((item, index) => {
                if (item.type === 'loyalty_points') {
                    return (
                        <tr key={`receipt-payment-loyalty-${index}`}>
                            <td className="currency align-right">${item.currency}<br/><br/></td>
                            <td className="pl">POINTS<br/><br/></td>
                        </tr>
                    )
                }
                if (item.type === 'cash') {
                    return (
                        <tr key={`receipt-payment-cash-${index}`}>
                            <td className="currency align-right">${item.currency}<br/><br/></td>
                            <td className="pl">CASH<br/><br/></td>
                        </tr>
                    )
                }
                if (item.type === 'out_of_scope') {
                    return (
                        <Fragment key={`receipt-payment-credit-${index}`}>
                            <tr key={`receipt-payment-credit-amount-${index}`}>
                                <td className="currency align-right">${item.currency}</td>
                                <td className="pl">{item.card_type}</td>
                            </tr>
                            <tr key={`receipt-payment-credit-last4-${index}`}>
                                <td className="align-right">Last 4 Digits:</td>
                                <td className="pl">{item.card_last4}</td>
                            </tr>
                            {item.authcode !== '' &&
                                <tr key={`receipt-payment-credit-auth-${index}`}>
                                    <td className="align-right">Auth:</td>
                                    <td className="pl">{item.authcode}</td>
                                </tr>
                            }
                            {item.pn_ref !== '' &&
                                <tr key={`receipt-payment-credit-inv-${index}`}>
                                    <td className="align-right">Inv:</td>
                                    <td className="pl">{item.pn_ref}</td>
                                </tr>
                            }
                            <tr key={`receipt-payment-credit-space-${index}`}>
                                <td colSpan={2}>
                                </td>
                            </tr>
                        </Fragment>
                    )
                }
                return (
                    <tr key={`receipt-payment-generic-${index}`}>
                        <td className="currency align-right">${item.currency}</td>
                        <td className="align-right currency">AMOUNT</td>
                    </tr>
                )
            })
        )
    };

    makeAdditionalTaxesRows = (list) => {
        if (!list || !list.length) {
            return (
                <tr key={`receipt-payments-empty`}>
                    <td colSpan={2}>
                    </td>
                </tr>
            )
        }
        return (
            list.map((item, index) => (
                <tr key={`${item.machine_name}-${index}`}>
                    <th colSpan={3} className="align-right">{item.name}:</th>
                    <th className="currency align-right">${item.currency}</th>
                </tr>
            ))
        )
    };

    makeAddress = (data) => {
        const city = (data.location_city) ? data.location_city + ', ' : '';
        const state = (data.location_state) ? data.location_state + ' ' : '';
        const zip = (data.location_zipcode) ? data.location_zipcode : '';
        return city + state + zip;
    };

    render() {
        const {
            data,
            payments,
            products,
            discounts
        } = this.props;

        return (
            <div className="reports-receipt-container">
                {/* Receipt Store Details */}
                <table>
                    <tbody>
                    <tr>
                        <td className="align-center">
                            {data.dba_name &&
                                <span className="bold">
                                {data.dba_name}<br/>
                            </span>
                            }
                            {data.location_address &&
                                <Fragment>
                                    {data.location_address}<br/>
                                </Fragment>
                            }
                            {(data.location_city || data.location_state || data.location_zipcode) &&
                                <Fragment>
                                    {this.makeAddress(data)}<br/>
                                </Fragment>
                            }
                            {data.dba_email &&
                                <Fragment>
                                    {data.dba_email}<br/>
                                </Fragment>
                            }
                            {data.location_telephone &&
                                <Fragment>
                                    {data.location_telephone}
                                </Fragment>
                            }
                            <br/>
                            <br/>
                        </td>
                    </tr>
                    {/* Transaction Date */}
                    <tr>
                        <td className="align-center">
                            {data.transaction_date_string}
                            <br/>
                            <br/>
                        </td>
                    </tr>
                    </tbody>
                </table>
                {/* Slip, Register, Clerk */}
                <table>
                    <tbody>
                    <tr>
                        <td colSpan={2} className="bold">
                            Slip #{data.seq}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Register: {data.register}
                        </td>
                        <td className="align-right">
                            Clerk: {data.user}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}>
                            {data.loyalty_id &&
                                <Fragment>
                                    <br/>
                                    Loyalty ID: #{data.loyalty_id}
                                </Fragment>
                            }
                        </td>
                    </tr>
                    </tbody>
                </table>

                {/* Discounts applied */}
                {discounts.length > 0 &&
                    <div>
                        <br/>
                        <table>
                            <thead>
                            <tr>
                                <th>Discount</th>
                                <th className="currency align-right">Total</th>
                            </tr>
                            </thead>
                            <tbody>
                            {[...this.makeDiscountRows(discounts)]}
                            <tr>
                                <td className="align-right">Total Discounted:</td>
                                <td className="currency align-right">{data.discount_total_string}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                }

                {/* Products purchased and totals */}
                {products.length > 0 &&
                    <div>
                        <br/>
                        <table>
                            <tbody>
                            <tr>
                                <td>Order Summary:</td>
                            </tr>
                            </tbody>
                        </table>
                        <table>
                            <thead>
                            <tr>
                                <th className="product truncate">Item</th>
                                <th className="qty align-right">Qty</th>
                                <th className="currency align-right">Price</th>
                                <th className="currency align-right">Total</th>
                            </tr>
                            </thead>
                            <tbody>
                            {[...this.makeProductRows(products)]}
                            <tr>
                                <td colSpan={4}><br/></td>
                            </tr>
                            <tr>
                                <th colSpan={3} className="align-right">Subtotal:</th>
                                <th className="currency align-right">${data.initial_net}</th>
                            </tr>
                            <tr>
                                <th colSpan={3} className="align-right">{data.location_tax_rate}% Tax:</th>
                                <th className="currency align-right">${data.initial_tax}</th>
                            </tr>
                            {[...this.makeAdditionalTaxesRows(this.state.additionalTaxTypes)]}
                            <tr>
                                <th colSpan={3} className="align-right">Total:</th>
                                <th className="currency align-right">${data.initial_total}</th>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                }

                {/* Payments (Points, Cash, Credit) */}
                {payments.length > 0 &&
                    <div>
                        <br/>
                        <table>
                            <thead>
                            <tr>
                                <th>Paid By:</th>
                                <th>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {[...this.makePaymentRows(payments)]}
                            </tbody>
                        </table>
                    </div>
                }

                <table>
                    <tbody>
                    <tr>
                        <td className="align-center">
                            <br/>
                            We Appreciate Your Business!
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default DialogSaleReceipt;



// WEBPACK FOOTER //
// ./src/Fuse/components/DialogSaleReceipt.js